// First-party branding assets (served from /public/branding).
export const LOGO_LIGHT = "/branding/logo-light.png";
export const LOGO_DARK = "/branding/logo-dark.png";
export const HERO_CARD_BG = "/branding/hero-card.png";
